<template>
  <div class="page-home">
    <article>
      <div
        v-for="(item, index) in totals"
        :key="item.title"
        :style="{
          marginRight: ![2, 5].includes(index) ? '20px' : '0px',
          display: 'inline-block',
          width: '32%',
        }"
      >
        <crm-block-total
          v-if="item.auth"
          :title="item.title"
          :titleImage="item.titleImage"
          :itemTitle="item.itemTitle"
          :contentItems="item.totals"
          :clickEvent="item.onClick"
        />
      </div>
    </article>
    <crm-panel
      v-loading="loading"
      :title="'销售漏斗'"
      v-if="
        auth.homeBusinessType && auth.homeBusinessType.toggleStatus === 1 ? true : false
      "
    >
      <div class="chart"></div>
    </crm-panel>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as echarts from "echarts";
import { toTenThousand, formatTimeShow } from "@/scripts/utils";
import CrmPanel from "@/components/base/crmPanel";
import CrmBlockTotal from "@/components/base/crmBlockTotal";
import moment from "moment";

export default {
  components: {
    CrmPanel,
    CrmBlockTotal,
  },
  data() {
    return {
      totals: [],
      // 是否是对内系统 env_crm__ true 默认是
      envCrm: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      auth: "authority/auth",
      homeCustom: "base/homeCustom",
      homeBusi: "base/homeBusi",
      homeContract: "base/homeContract",
      homeCustomVisit: "base/homeCustomVisit",
      homeChartData: "base/homeChartData",
      homeProject: "base/homeProject",
      homeMedicalCustomer: "base/homeMedicalCustomer",
    }),
  },
  created() {
    const p = [];
    if (this.auth.homeCustomer && this.auth.homeCustomer.toggleStatus) {
      p.push(this.getHomeCustom());
    }
    if (this.auth.homeBusiness && this.auth.homeBusiness.toggleStatus) {
      p.push(this.getHomeBusi());
    }
    if (this.auth.homeContract && this.auth.homeContract.toggleStatus) {
      p.push(this.getHomeContract());
    }
    if (this.auth.homeProject && this.auth.homeProject.toggleStatus) {
      p.push(this.getHomeProject());
    }
    if (this.auth.homeVisit && this.auth.homeVisit.toggleStatus) {
      p.push(this.getHomeCustomVisit());
    }
    if (this.auth?.homeMedicalCustomer?.toggleStatus) {
      p.push(this.getHomeMedicalCustomer());
    }

    Promise.all(p).then(() => {
      this.handleCusData();
      this.handleBusiData();
      this.handleContractData();
      this.handleProjectData();
      this.handleVisitData();
      this.handleMedicalData();
    });
  },
  mounted() {
    this.envCrm = cookie.get("_env_crm__") !== "false";
    if (this.auth.homeBusinessType && this.auth.homeBusinessType.toggleStatus) {
      this.loading = true;
      this.getHomeChartData()
        .then(() => {
          this.drawChart();
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  destroyed() {
    console.log("---->", this.auth);
  },
  methods: {
    ...mapActions({
      getHomeCustom: "base/getHomeCustom",
      getHomeBusi: "base/getHomeBusi",
      getHomeContract: "base/getHomeContract",
      getHomeCustomVisit: "base/getHomeCustomVisit",
      getHomeChartData: "base/getHomeChartData",
      getHomeProject: "base/getHomeProject",
      getHomeMedicalCustomer: "base/getHomeMedicalCustomer",
    }),
    handleCusData() {
      if (this.auth.homeCustomer && this.auth.homeCustomer.toggleStatus) {
        this.totals.push({
          title: "客户统计",
          auth: this.auth.homeCustomer && this.auth.homeCustomer.toggleStatus,
          titleImage: require("@/images/home/quantity@2x.png"),
          itemTitle: ["昨日新增", "客户总数", "本月新增"],
          totals: [
            toTenThousand(this.homeCustom.yesterdayAdd),
            toTenThousand(this.homeCustom.customerCount),
            toTenThousand(this.homeCustom.monthAdd),
          ],
          onClick: [
            () =>
              this.handleToCustomer({
                time: [
                  formatTimeShow(new Date(new Date() - 86400000).getTime()),
                  formatTimeShow(new Date(new Date() - 86400000).getTime()),
                ],
              }),
            () => this.handleToCustomer(),
            () =>
              this.handleToCustomer({
                time: [formatTimeShow(new Date().setDate(1)), formatTimeShow(new Date())],
              }),
          ],
        });
      }
    },
    handleBusiData() {
      if (this.auth.homeBusiness && this.auth.homeBusiness.toggleStatus) {
        this.totals.push({
          title: "商机统计",
          auth: this.auth.homeBusiness && this.auth.homeBusiness.toggleStatus,
          titleImage: require("@/images/home/business@2x.png"),
          itemTitle: ["本月新增", "商机总数", "本月阶段变化商机"],
          totals: [
            toTenThousand(this.homeBusi.mouthAdd),
            toTenThousand(this.homeBusi.businessCount),
            toTenThousand(this.homeBusi.busiChangeNumber),
          ],
          onClick: [
            () =>
              this.handleToBusiness({
                searchDateType: 1,
                datePicker: [
                  formatTimeShow(new Date().setDate(1)),
                  formatTimeShow(new Date()),
                ],
              }),
            () => this.handleToBusiness(),
            () =>
              this.handleToBusiness({
                searchDateType: 2,
                datePicker: [
                  formatTimeShow(new Date().setDate(1)),
                  formatTimeShow(new Date()),
                ],
              }),
          ],
        });
      }
    },
    handleContractData() {
      if (this.auth.homeContract && this.auth.homeContract.toggleStatus) {
        this.totals.push({
          title: "回款统计",
          auth: this.auth.homeContract && this.auth.homeContract.toggleStatus,
          titleImage: require("@/images/home/contract@2x.png"),
          itemTitle: ["本月回款", "今年回款", "本季度回款"],
          totals: [
            toTenThousand(this.homeContract.mouthRefundMoney, true),
            toTenThousand(this.homeContract.yearsRefundMoney, true),
            toTenThousand(this.homeContract.quarterRefundMoney, true),
          ],
          onClick: [
            () =>
              this.handleToContractBack({
                searchDateType: 1,
                searchTime: [
                  moment().startOf("Y").format("YYYY-MM-DD"),
                  moment().format("YYYY-MM-DD"),
                ],
              }),
            () =>
              this.handleToContractBack({
                searchDateType: 1,
                searchTime: [
                  formatTimeShow(new Date().setDate(1)),
                  formatTimeShow(new Date()),
                ],
              }),
            () =>
              this.handleToContractBack({
                searchDateType: 1,
                searchTime: [
                  moment().startOf("M").add(-3, "M").format("YYYY-MM-DD"),
                  moment().startOf("M").add(-1).format("YYYY-MM-DD"),
                ],
              }),
          ],
        });
      }
    },
    handleVisitData() {
      if (this.auth.homeVisit && this.auth.homeVisit.toggleStatus) {
        this.totals.push({
          title: "跟进统计",
          auth: this.auth.homeVisit && this.auth.homeVisit.toggleStatus,
          titleImage: require("@/images/home/customer@2x.png"),
          itemTitle: ["本月拜访次数", "昨日拜访次数", "昨日拜访对象数"],
          totals: [
            toTenThousand(this.homeCustomVisit.mouthRecord),
            toTenThousand(this.homeCustomVisit.yesterdayRecord),
            toTenThousand(this.homeCustomVisit.yesterdayCustomer),
          ],
          onClick: [
            () =>
              this.handleToVisit({
                time: [formatTimeShow(new Date().setDate(1)), formatTimeShow(new Date())],
              }),
            () =>
              this.handleToVisit({
                time: [
                  formatTimeShow(new Date(new Date() - 86400000).getTime()),
                  formatTimeShow(new Date(new Date() - 86400000).getTime()),
                ],
              }),
            () =>
              this.handleToVisit({
                time: [
                  formatTimeShow(new Date(new Date() - 86400000).getTime()),
                  formatTimeShow(new Date(new Date() - 86400000).getTime()),
                ],
              }),
          ],
        });
      }
    },
    handleProjectData() {
      if (this.auth?.homeMedicalCustomer?.toggleStatus) {
        this.totals.push({
          title: "医生客户",
          auth: this.auth?.homeMedicalCustomer?.toggleStatus,
          titleImage: "https://kano.guahao.cn/iPc561324780",
          itemTitle: ["昨日新增", "医生客户总数", "本月新增"],
          totals: [
            toTenThousand(this.homeMedicalCustomer.yesterdayAdd, false),
            toTenThousand(this.homeMedicalCustomer.medicalCustomerCount, false),
            toTenThousand(this.homeMedicalCustomer.mouthAdd, false),
          ],
          onClick: [
            () =>
              this.handleToMedicalCustomer({
                // searchDateType: 1,
                searchTime: [
                  moment().startOf("M").format("YYYY-MM-DD"),
                  moment().format("YYYY-MM-DD"),
                ],
              }),
            () =>
              this.handleToMedicalCustomer({
                // searchDateType: 1,
                // searchTime: [
                //   formatTimeShow(new Date().setDate(1)),
                //   formatTimeShow(new Date()),
                // ],
              }),
            () =>
              this.handleToMedicalCustomer({
                // searchDateType: 1,
                searchTime: [
                  moment().startOf("M").add(-3, "M").format("YYYY-MM-DD"),
                  moment().startOf("M").add(-1).format("YYYY-MM-DD"),
                ],
              }),
          ],
        });
      }
    },
    handleMedicalData() {
      if (this.auth.homeProject && this.auth.homeProject.toggleStatus) {
        this.totals.push({
          title: "项目统计",
          auth: this.auth.homeProject && this.auth.homeProject.toggleStatus,
          titleImage: require("@/images/home/icon_xmtj.png"),
          itemTitle: ["本月项目数", "项目总数", "本季度项目数"],
          totals: [
            toTenThousand(this.homeProject.monthCount, false),
            toTenThousand(this.homeProject.projectCount, false),
            toTenThousand(this.homeProject.quarterCount, false),
          ],
          onClick: [
            () =>
              this.handleToProject({
                // searchDateType: 1,
                searchTime: [
                  moment().startOf("M").format("YYYY-MM-DD"),
                  moment().format("YYYY-MM-DD"),
                ],
              }),
            () =>
              this.handleToProject({
                // searchDateType: 1,
                // searchTime: [
                //   formatTimeShow(new Date().setDate(1)),
                //   formatTimeShow(new Date()),
                // ],
              }),
            () =>
              this.handleToProject({
                // searchDateType: 1,
                searchTime: [
                  moment().startOf("M").add(-3, "M").format("YYYY-MM-DD"),
                  moment().startOf("M").add(-1).format("YYYY-MM-DD"),
                ],
              }),
          ],
        });
      }
    },
    handleToCustomer(params) {
      this.$router.push({
        name: "customerValid",
        params,
      });
    },
    handleToBusiness(params) {
      this.$router.push({
        name: "opportunity",
        params,
      });
    },
    handleToContractBack(params) {
      this.$router.push({
        name: "moneyback",
        params,
      });
    },
    handleToContract(params) {
      this.$router.push({
        name: "contract",
        params,
      });
    },
    handleToVisit(params) {
      this.$router.push({
        name: "visit",
        params,
      });
    },
    handleToProject(params) {
      if (this.envCrm) {
        this.$router.push({
          name: "crmProjectManagement",
          params,
        });
      } else {
        this.$router.push({
          name: "memberProject",
          params,
        });
      }
    },
    handleToMedicalCustomer(params) {
      this.$router.push({
        name: "medicalCusVaild",
        params,
      });
    },
    drawChart() {
      const myChart = echarts.init(document.querySelector(".chart"), "light");

      const dataLabel = {};
      this.homeChartData.forEach((i) => {
        dataLabel[i.typeNo] = `${i.businessTypeStr}: ${i.busiNumber}个`;
      });
      const legendData = [
        "建立关系",
        "识别商机",
        "提出方案",
        "确定方案",
        "确定协议",
        "签订合同",
        "验收回款",
      ];
      for (let num = 1; num <= 7; num += 1) {
        if (!dataLabel[num]) dataLabel[num] = `${legendData[num - 1]}: 0个`;
      }
      const seriesData = [
        {
          name: "建立关系",
          value: 100,
          label: {
            show: true,
            position: "right",
            formatter: dataLabel[1],
          },
          tooltip: {
            formatter: dataLabel[1],
          },
        },
        {
          name: "识别商机",
          value: 85.72,
          label: {
            show: true,
            position: "right",
            formatter: dataLabel[2],
          },
          tooltip: {
            formatter: dataLabel[2],
          },
        },
        {
          name: "提出方案",
          value: 71.44,
          label: {
            show: true,
            position: "right",
            formatter: dataLabel[3],
          },
          tooltip: {
            formatter: dataLabel[3],
          },
        },
        {
          name: "确定方案",
          value: 57.16,
          label: {
            show: true,
            position: "right",
            formatter: dataLabel[4],
          },
          tooltip: {
            formatter: dataLabel[4],
          },
        },
        {
          name: "确定协议",
          value: 42.88,
          label: {
            show: true,
            position: "right",
            formatter: dataLabel[5],
          },
          tooltip: {
            formatter: dataLabel[5],
          },
        },
        {
          name: "签订合同",
          value: 28.6,
          label: {
            show: true,
            position: "right",
            formatter: dataLabel[6],
          },
          tooltip: {
            formatter: dataLabel[6],
          },
        },
        {
          name: "验收回款",
          value: 14.32,
          label: {
            show: true,
            position: "right",
            formatter: dataLabel[7],
          },
          tooltip: {
            formatter: dataLabel[7],
          },
        },
      ];
      const option = {
        legend: {
          data: legendData,
        },
        tooltip: {
          trigger: "item",
          formatter: "0元",
        },
        calculable: true,
        series: [
          {
            name: "销售漏斗",
            type: "funnel",
            min: 0,
            max: 100,
            minSize: "0%",
            maxSize: "60%",
            sort: "descending",
            data: seriesData,
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less">
.page-home {
  width: 100%;
  .chart {
    width: 800px;
    height: 500px;
    margin: 40px auto;
  }
}
</style>
